import { makeStyles } from '@mui/styles';
import Tab from 'apollo-react/components/Tab';
import Tabs from 'apollo-react/components/Tabs';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOpenErrorsTabEntityDisplay } from './selectors';
import TaskStatus from './TaskStatus';
import { setOpenErrorsTabEntityDisplay } from '../../actions/EntityDisplayActions';
import { setPanelLayoutConfig } from '../../actions/PanelLayoutActions';
import ErrorDisplay from '../../components/ErrorDisplay';
import { ERRORS } from '../../constants/Common';
import {
  LEFT_PANEL_COLLAPSE_EXPAND_MAP,
  LEFT_PANEL_EXPAND_COLLAPSE_MAP,
} from '../../constants/PanelLayoutConstants';
import { usePrevious } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'transparent',
    padding: '0px 10px',
    height: '100%',
    maxHeight: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  tabs: {
    marginBottom: 20,
  },
});

const TASK_STATUS_TAB_INDEX = 0;
const ERROR_DISPLAY_TAB_INDEX = 1;

function LeftPanel({ errors, taskStatusDisabled }) {
  const previousErrorsCount = usePrevious(errors.length);
  const panelConfig = useSelector((state) => state.panelLayout.config);
  const openErrorsTab = useSelector(getOpenErrorsTabEntityDisplay);
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const errorsTitle = translateString(ERRORS);

  const [currentTab, setCurrentTab] = useState(0);

  const tabContent = [<TaskStatus key="TaskStatus" />, <ErrorDisplay key="ErrorDisplay" />];

  const handleTabChange = (_, tabValue) => {
    setCurrentTab(tabValue);
  };

  const openPanel = () => {
    const newConfig = LEFT_PANEL_COLLAPSE_EXPAND_MAP[panelConfig];

    if (!_.isNil(newConfig)) {
      dispatch(setPanelLayoutConfig(newConfig));
    }
  };

  const closePanel = () => {
    const newConfig = LEFT_PANEL_EXPAND_COLLAPSE_MAP[panelConfig];

    if (!_.isNil(newConfig)) {
      dispatch(setPanelLayoutConfig(newConfig));
    }
  };

  const openErrorDisplay = () => {
    openPanel();
    setCurrentTab(ERROR_DISPLAY_TAB_INDEX);
  };

  useEffect(() => {
    if (previousErrorsCount !== errors.length) {
      if (errors.length > 0) {
        openErrorDisplay();
      } else if (!taskStatusDisabled) {
        setCurrentTab(TASK_STATUS_TAB_INDEX);
      } else {
        closePanel();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  useEffect(() => {
    if (
      (panelConfig in LEFT_PANEL_COLLAPSE_EXPAND_MAP || currentTab !== ERROR_DISPLAY_TAB_INDEX) &&
      openErrorsTab
    ) {
      openErrorDisplay();
      dispatch(setOpenErrorsTabEntityDisplay(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openErrorsTab, panelConfig, currentTab]);

  return (
    <div className={classes.root} ui-ta="ScrollingElement">
      <Tabs className={classes.tabs} value={currentTab} onChange={handleTabChange}>
        <Tab label={translateString('Task Status')} disabled={taskStatusDisabled} />
        <Tab label={`${errorsTitle} (${errors.length})`} disabled={errors.length < 1} />
      </Tabs>
      {tabContent[currentTab]}
    </div>
  );
}

export default LeftPanel;
